<template>
  <div class="messageBorder">
    <!-- 留言板 -->
    <div v-if="messageStatus === 0">
      <div class="title">
        留言板管理
        <p></p>
      </div>

      <div class="tab_div">
        <el-table
          :header-cell-style="{background: '#f2f2f2',color: '#333333',fontSize: '14px'}"
          :row-style="{height: '50px'}"
          border
          :data="messageList"
        >
          <el-table-column header-align="center" align="center" width="310" label="标题" prop="title"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            width="315"
            label="反馈时间"
            prop="createDate"
          ></el-table-column>
          <el-table-column header-align="center" align="center" width="233" label="操作">
            <template slot-scope="scope">
              <el-button type="text" class="caoz" @click="seeMessage(scope.row.id)">查看</el-button>
              <el-button type="text" class="caoz" @click="deleteMessage(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="fenye">
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="infomationList.length"
          layout="slot"
        >
          <span style="color: #7a7a7a;font-size: 12px;margin-right: 15px;line-height: 36px;">
            共
            {{ totalIndex }}
            页
          </span>
          <el-button :disabled="firstPageBtnDisabled" class="first-pager" @click="toFirstPage"><< 首页</el-button>
        </el-pagination>
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="infomationList.length"
          layout="pager, next, slot, jumper "
        >
          <el-button :disabled="lastPageBtnDisabled" class="first-pager" @click="toLastPage">>> 尾页</el-button>
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <div class="messageInfo" v-if="messageStatus === 1">
      <div class="title">
        留言板详情
        <p></p>
      </div>

      <p class="infoTitle">留言板标题</p>
      <div class="infoContent" v-html="content"></div>
      <el-button @click="back">返回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      messageStatus: 0,
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false,
      infomationList: [],
      pageSize: 5, // 每页条数
      pageIndex: 1, // 当前页
      totalPage: 0, // 总条数
      totalIndex: 0,
      messageList: [],
      content: "",
    };
  },
  mounted() {
    if (this.infomationList.length > 0) {
      this.firstPageBtnDisabled = false;
      this.lastPageBtnDisabled = false;
    } else {
      this.firstPageBtnDisabled = true;
      this.lastPageBtnDisabled = true;
    }
    this.getAllMessage();
  },
  methods: {
    // 所有留言
    getAllMessage() {
      this.$http
        .get("getMessageByUserId")
        .then(({ data }) => {
          let { code, getMessageByUserIdList } = data;
          if (code === 0) {
            getMessageByUserIdList.forEach((element) => {
              element.createDate = element.createDate.substring(0, 10);
            });
            this.totalIndex = Math.ceil(
              getMessageByUserIdList.length / this.pageSize
            );
            this.messageList = getMessageByUserIdList;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
    },
    // 返回
    back() {
      this.messageStatus = 0;
    },
    // 查看
    seeMessage(id) {
      this.messageStatus = 1;
      this.$http({
        url: "getMessageInfoById",
        method: "post",
        params: {
          id: id,
        },
      })
        .then(({ data }) => {
          let { code, MessageInfo } = data;
          if (code === 0) {
            this.content = MessageInfo.content;
          }
        })
        .catch((err) => console.log(err));
    },
    // 删除
    deleteMessage(id) {
      this.$confirm("确认删除当前留言？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "deleteMessageById",
          method: "post",
          params: {
            id: id,
          },
        }).then(({ data }) => {
          if (data.code === 0) {
            this.$message({
              message: `留言删除成功！`,
              type: "success",
              duration: 500,
              onClose: () => {
                this.getAllMessage();
              },
            });
          }
        });
      });
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.firstPageBtnDisabled = val === 1 ? true : false;
      this.lastPageBtnDisabled = val === this.lastPageNum ? true : false;
    },
    // 首页
    toFirstPage() {
      this.pageIndex = 1;
      this.lastPageBtnDisabled = false;
      this.firstPageBtnDisabled = true;
    },
    // 尾页
    toLastPage() {
      this.pageIndex = this.lastPageNum;
      this.firstPageBtnDisabled = false;
      this.lastPageBtnDisabled = true;
    },
  },
};
</script>
<style lang="scss">
.messageBorder {
  .el-table th > .cell {
    padding: 8px;
  }
  .el-table th,
  .el-table td {
    padding: 5px 0;
  }

  .el-table--border th,
  .el-table--border td {
    border-right: 1px solid #e5e5e5;
  }

  .fenye {
    height: 32px;
    text-align: center;
    margin-top: 57px;
    margin-left: 32%;
    .el-pagination {
      width: 121px;
      float: left;
      .el-pager {
        height: 32px;
        li:not(.disabled).active {
          background-color: #2878ff;
          color: #ffffff;
          &:hover {
            color: #ffffff;
          }
        }
        .number:hover {
          color: #9ea4b9;
        }
      }
      .btn-next,
      .number {
        width: 32px;
        height: 32px;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        line-height: 32px;
        color: #9ea4b9;
        background-color: #ffffff;
      }
      .el-pagination__jump {
        height: 32px;
        line-height: 32px;
        margin-left: 15px;
      }
    }
    .first-pager {
      width: 74px;
      height: 32px;
      border: 1px solid #e6e6e6;
      border-radius: 5px;
      text-align: center;
      color: #9ea4b9;
      &:focus,
      &:hover {
        background-color: #ffffff;
      }
    }
  }
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2878ff;
}
</style>
<style lang="scss" scoped>
.messageBorder {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 90px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
}
.tab_div {
  width: 860px;
  height: 409px;
  margin: 20px 0 0 30px;
}
.messageInfo {
  width: 860px;
  margin: 50px 0 0 30px;
  .infoTitle {
    height: 28px;
    line-height: 28px;
    font-size: 28px;
    color: #333333;
    text-align: center;
  }
  .infoContent {
    height: 225px;
    border: 1px solid blue;
    margin: 65px 0 173px 0;
  }
  .el-button {
    width: 160px;
    height: 50px;
    color: #ffffff;
    font-size: 14px;
    background-color: #143372;
    margin-left: 350px;
  }
}
</style>